import moment from 'moment';
import { useState } from 'react';
import { DayPicker } from '../../components/DayPicker';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/Popover';
import { CalendarIcon } from '../../components/svgs/icons/CalendarIcon';
import { Button } from '../Button';
import { Input, InputAddon, InputGroup } from '../Input';

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const DateInput = ({ value, onChange }: Props) => {
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);

	return (
		<div>
			<InputGroup>
				<InputAddon mode='icon'>
					<Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
						<PopoverTrigger>
							<Button
								size='icon'
								variant='link'
								onClick={e => {
									e.stopPropagation();
									setIsCalendarOpen(true);
								}}
							>
								<CalendarIcon />
							</Button>
						</PopoverTrigger>
						<PopoverContent side='bottom'>
							<DayPicker
								className={`Selectable`}
								selectedDays={value ? new Date(value) : undefined}
								numberOfMonths={1}
								onDayClick={day => {
									onChange(moment(day).format('YYYY-MM-DD'));
								}}
							/>
						</PopoverContent>
					</Popover>
				</InputAddon>

				<Input
					value={value}
					onChange={e => onChange(e.target.value)}
					placeholder={moment(value).format('YYYY-MM-DD')}
				/>
			</InputGroup>
		</div>
	);
};
